import { VehicleUnitSizeModal } from 'components/unit/VehicleUnitSizeModal';
import { withProps } from 'recompose';
import { vehicleAccommodationDescriptions } from 'config/units';


const enhance = withProps({
	unitSizes: vehicleAccommodationDescriptions,
	segmentLabel: 'vehicle accommodations modal',
	title: 'Vehicle Accommodations Guide'
});

export default enhance(VehicleUnitSizeModal);
